module.exports = __webpack_public_path__ + "Roboto-Medium.d08840599e05db734565.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Medium.ttf
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Medium.ttf
// module chunks = styles